import React, { useEffect, useState } from 'react';
//FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//hook
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
//style
import styles from 'src/asset/scss/style/sales.module.scss';

export default function ReservInfodata(props) {
    const { data } = props;//props
    const { windowSizes, windowResizeHandler } = useComnHook();//화면사이즈useRef, 화면사이즈핸들러

    useEffect(() => {
        windowResizeHandler();//화면사이즈핸들러
	} ,[]);
    
    /* =============== 카테고리필터 =============== */
    const categoryFilter = (type) => {
        switch(type) {
            case 1 : return '엔진오일';
            case 2 : return '타이어';
            case 3 : return '정기점검';
            case 4 : return '기타';
        }
    }
    /* =============== 카테고리필터 =============== */
    /* =============== 체크항목 =============== */
    const optionFiler = () => {
        let option = '';
        for(let i = 0; i < 4; i++) {
            let str = '';
            if(i === 0 && data.TYPE_AIR === 1) { str = '공기압'; }
            if(i === 1 && data.TYPE_BRAKE === 1) { str = '브레이크 패드 마모'; }
            if(i === 2 && data.TYPE_COOL === 1) { str = '냉각수'; }
            if(i === 3 && data.TYPE_TIRE === 1) { str = '타이어마모'; }

            if(str.length > 0) { option += (option.length > 0 ? ' | ' + str : str); }
        }
        return option;
    }
    /* =============== 체크항목 =============== */
    /* =============== mobile사이즈일때 토글 =============== */
    const [ toggle,setToggle ] = useState(null);
    /* =============== mobile사이즈일때 토글 =============== */

    return (
        <div className={styles.bottomsheetReservInfoContainer}>
            <div className={styles.profileContainer}>
                <div className={styles.imgArea}><img src={`${process.env.REACT_APP_IMAGE_URL + data.MODEL_IMG_SRC}`} alt={data.ORDER_NO} /></div>
                <div className={styles.memberInfoArea}>
                    <h1>{data.MARKING_MEMBER_NAME}</h1>
                    <p>{data.RESERV_CNT}회 재예약 | {data.NOSHOW_CNT}노쇼</p>
                </div>
            </div>	
            <div className={styles.reservContainer}>
                <dl>
                    <dd>
                        <h2>차종</h2>
                        <p>{data.MODEL_KOR_NAME}</p>
                    </dd>
                    <dd>
                        <h2>카테고리</h2>
                        {data.CATEGORY_LIST !== undefined && data.CATEGORY_LIST.length > 0 ? <p>{data.CATEGORY_LIST.map((item, idx) => <span key={idx}>{categoryFilter(item.CATEGORY)}</span> )}</p> : null}
                    </dd>
                </dl>
                <dl>
                    <dd>
                        <h2>체크항목</h2>
                        <p>{optionFiler()}</p>
                    </dd>
                    <dd>
                        <h2>항목</h2>
                        {data.ITEM_LIST !== undefined && data.ITEM_LIST.length > 0 ? <p>{data.ITEM_LIST.map((item, idx) => <span key={idx}>{item.ITEM_NAME}</span> )}</p> : null}
                    </dd>
                </dl>
                {data.CONTENT !== undefined && data.CONTENT !== null ?
                    <div>
                        <h3 onClick={(e) => windowSizes.current.width <= 767 ? setToggle(toggle === 'content' ? null : 'content') : null}><span>요청사항</span><button>{toggle === 'content' ? <FontAwesomeIcon icon="fa-light fa-chevron-up" /> : <FontAwesomeIcon icon="fa-light fa-chevron-down" /> }</button></h3>
                        {toggle === 'content' || windowSizes.current.width > 767 ? <p>{data.CONTENT}</p> : null}
                    </div>
                : null}
                {data.RESULT !== undefined && data.RESULT !== null ?
                    <div>
                        <h3 onClick={(e) => windowSizes.current.width <= 767 ? setToggle(toggle === 'result' ? null : 'result') : null}><span>정비이력</span><button>{toggle === 'result' ? <FontAwesomeIcon icon="fa-light fa-chevron-up" /> : <FontAwesomeIcon icon="fa-light fa-chevron-down" /> }</button></h3>
                        {toggle === 'result' || windowSizes.current.width > 767 ? <p>{data.RESULT}</p> : null}
                    </div>
                : null}
                <div className={styles.priceArea}>
                    <h3>정비금액</h3>
                    <span>{data.TOT_PRICE}원</span>
                </div>
            </div>
        </div>
	);
  }